import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import categories from "../../assets/Data/categories";
import "./LatestCollection.css";
import ProductCard from "../ProductCard/ProductCard";

function LatestCollection() {
  const latestProducts = categories.flatMap((category) =>
    category.products
      .filter((product) => product.islatestCollection)
      .map((item) => ({ ...item, categories: category }))
  );

  return (
    <div className="ltsCol">
      <div className="maxW">
        <h2>LATEST COLLECTION</h2>
      <Swiper
  modules={[Autoplay]}
  loop={true}
  spaceBetween={20}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
  }}
  breakpoints={{
    2304: { slidesPerView: 7},
    1800: { slidesPerView:  6 },
    1600: { slidesPerView: 4.6 },
    1500: { slidesPerView: 4 },
    1518: { slidesPerView: 4 },
    1400: { slidesPerView: 4 },
    1300: { slidesPerView: 3.5 },
    1200: { slidesPerView: 3.5 },
    1100: { slidesPerView: 3.5 },
    1024: { slidesPerView: 4 },
    768: { slidesPerView: 3},
    742: { slidesPerView: 2},
    540: { slidesPerView: 1.5 },
    320: { slidesPerView: 1 },
  }}
      >
        {latestProducts.map((product, index) => (
          <SwiperSlide key={product.productId || index}>
            <div className="swpMn">
              <div className="swpCon">
                <div className="ltstCard">
                  <ProductCard
                    {...product}
                    title={product.categories.title}
                    catId={product.categories.catId}
                    link={product.categories.link}
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </div>
  );
}

export default LatestCollection;

